import React, { Component } from 'react'
import './index.scss'

import i18n from '@/i18n'

class EasyUse extends Component {
    renderItems = () => {
        const items = [
            {
                img: 'https://front.videomonster.com/images-7cuytg20/web/home/easyuse-icon-designselect.svg',
                title: i18n.t("web.newhome.easyuse.icon.designselect.title"),
                desc: i18n.t("web.newhome.easyuse.icon.designselect.desc")
            },
            {
                img: 'https://front.videomonster.com/images-7cuytg20/web/home/easyuse-icon-input.svg',
                title: i18n.t("web.newhome.easyuse.icon.input.title"),
                desc: i18n.t("web.newhome.easyuse.icon.input.desc")
            },
            {
                img: 'https://front.videomonster.com/images-7cuytg20/web/home/easyuse-icon-download.svg',
                title: i18n.t("web.newhome.easyuse.icon.download.title"),
                desc: i18n.t("web.newhome.easyuse.icon.download.desc")
            }
        ]

        return (
            <div className='item-container'>
                {
                    items.map(({ img, title, desc }, index) => (
                        <>
                            {
                                index !== 0 &&
                                <img className='arrow' src='https://front.videomonster.com/images-7cuytg20/web/home/easyuse-arrow.svg' alt='' />
                            }
                            <div className='item-wrapper'>
                                <img src={img} alt='' />
                                <div className='title'>{title}</div>
                                <div className='desc'>{desc}</div>
                            </div>
                        </>
                    ))
                }
            </div>
        )
    }

    render() {
        return (
            <div className='easy-use-root-container'>
                <div className='subtitle'>So, Easy</div>
                <div className='heading'>{i18n.t("web.newhome.easyuse.title")}</div>
                {this.renderItems()}
            </div>
        )
    }
}

export default EasyUse